export default __webpack_public_path__ + "static/media/SharePizza_07.78d25f8a.png";